module.exports = __webpack_public_path__ + "static/media/hyper-2.045f22ee.PNG";